import Logger from '../logger';


export default class DefaultsParam {

  static filterInput(params) {
    // validate input values
    const settings = {};
    const defaultsParam = DefaultsParam.input;
    for (let properties in defaultsParam) {
      if (Object.prototype.hasOwnProperty.call(defaultsParam, properties)) {
        if (typeof params[properties] !== 'undefined') {
          if (properties === 'shakaCustomRequestFilter' ||
            properties === 'shakaCustomResponseFilter' ||
            properties === 'shakaDrmFairPlayInitDataTransform' ||
            properties === 'p2pMediaLoaderEngine' ||
            properties === 'playlistCallback' ||
            properties === 'relatedCallback' ||
            properties === 'adScheduleCallback' ||
            properties === 'cuePointsCallback' ||
            properties === 'adImaDaiVodPodRequestStreamURLCallback') {
            if (typeof params[properties] === 'function') {
              settings[properties] = params[properties];
            } else {
              settings[properties] = null;
            }
          } else if (typeof params[properties] !== typeof defaultsParam[properties]) {
            Logger.print('filter', 'invalid input settings (typeof): ' + properties + ' - using default');
            settings[properties] = defaultsParam[properties];
          } else {
            settings[properties] = params[properties];
          }
        } else {
          settings[properties] = defaultsParam[properties];
        }
        if (typeof settings[properties] === 'string') {
          settings[properties] = (settings[properties]).trim();
        }
      }
    }
    for (let properties in settings) {
      if (Object.prototype.hasOwnProperty.call(settings, properties)) {
        this[properties] = settings[properties];
      }
    }
  }

  static filterRetryParameters() {
    const defaultsRetryParameters = DefaultsParam.retryParameters;
    if (Object.keys(this.retryParameters).length === 0) {
      this.retryParameters = defaultsRetryParameters;
    } else {
      let keys = Object.keys(defaultsRetryParameters);
      keys.forEach(key => {
        if (typeof this.retryParameters[key] === 'undefined') {
          this.retryParameters[key] = defaultsRetryParameters[key];
        } else {
          let subKeys = Object.keys(defaultsRetryParameters[key]);
          subKeys.forEach(subKey => {
            if (typeof this.retryParameters[key][subKey] !== 'number' || this.retryParameters[key][subKey] < 0) {
              this.retryParameters[key][subKey] = defaultsRetryParameters[key][subKey];
            }
          });
        }
      });
    }
    Logger.print('filter', 'retryParameters:', this.retryParameters);
  }

  static get input() {
    return {
      licenseKey: '',
      width: 640,
      height: 360,
      iframeMode: false,
      iframeAllowed: true,
      autoHeightMode: false,
      autoHeightModeRatio: 16 / 9,
      backgroundColor: '000000',
      skin: 's1',
      iconsSet: 'font-awesome',
      iconsSize: 1,
      customIconsLoc: '',
      iconSpinner: 'classic',
      fullWindowSkin: false,
      skinBackgroundColor: '',
      skinButtonColor: '',
      skinAccentColor: '',
      hideControls: false,
      hideCentralPlayButton: false,
      hideCentralBuffering: false,
      hideSeekBar: false,
      hideFullscreen: false,
      hideVolume: false,
      hideExternalPlayerLabels: false,
      disableKeyboardControl: false,
      longFormContent: false,
      automaticFullscreenOnLandscape: true,
      automaticLandscapeOnFullScreen: true,
      fullscreenFullWindowMode: false,
      fixedLabelsLanguage: '',
      doubleClickForFullscreen: true,
      pauseContentWhenViewingAreaIsClicked: true,
      autoplay: false,
      autoplayCount: Infinity,
      requestAutoplayCapabilitiesData: false,
      detectAutoplayTimeout: -1,
      viewableAutoplay: false,
      viewablePlayPause: false,
      viewableThreshold: 0.5,
      srcChangeAutoplay: true,
      posterScaleMode: 'letterbox',
      autoplayAnimatedPoster: false,
      hideInitialBlackFrameWhenNoPoster: true,
      scaleMode: 'letterbox',
      loop: false,
      muted: false,
      permanentMuted: false,
      initialVolume: 1,
      forceInitialVolume: false,
      rememberVolume: true,
      rememberCurrentTime: false,
      rememberQuality: false,
      bitrateDataDisplayed: 'kbps',
      displayCodecData: false,
      preload: 'smart',
      delayToFade: 3500,
      contentMetadata: {},
      appName: '',
      logo: {
        imgUri: '',
        clickUri: '',
        position: 'topleft',
        margin: '8px',
        watermark: false,
        pauseContentOnLogoClick: true
      },
      sharing: false,
      sharingUrl: '',
      sharingCode: '',
      sharingNetworks: ['facebook', 'x', 'email'],
      frameRate: -1,
      strictGdprCompliance: false,
      displayRemainingTimeInPlaceOfDuration: false,
      errorOnlyShowCustomText: false,
      customTrackNames: {
        captions: [],
        quality: [],
        audio: []
      },
      playerContainerRole: 'application',
      // UI
      flipVideo: {
        x: 0,
        y: 0,
        z: 0
      },
      // audio-only
      audioOnly: false,
      audioOnlyUseVideoLayout: false,
      audioOnlyIcecast: false,
      audioOnlyID3UI: false,
      debugLevel: 1,
      debugForceRawConsoleLogs: false,
      pathToRmpFiles: '.',
      offsetStartPosition: 0,
      quickRewind: 0,
      quickForward: 0,
      ajaxWithCredentials: false,
      allowLocalStorage: true,
      // captions
      autoBumpCaptionsOnVisibleControlBar: true,
      // pip
      pip: true,
      // floating
      floating: false,
      floatingThreshold: 0.5,
      // retryParameters
      retryParameters: {},
      // Shaka
      shakaRestrictions: {},
      shakaDrm: {},
      shakaDrmEmeFairPlay: false,
      shakaRequestConfiguration: {},
      shakaCustomConfig: {},
      shakaFullCustomConfig: {},
      shakaCustomRequestFilter: null,
      shakaCustomResponseFilter: null,
      shakaDrmFairPlayInitDataTransform: null,
      shakaKeySystemsByURI: {},
      shakaOffline: false,
      shakaOfflinePreferredTrackQuality: -1,
      shakaMaxBufferAhead: 30,
      shakaMaxBufferBehind: 30,
      shakaClearBufferSwitch: true,
      shakaLiveSync: true,
      shakaAWSMediaTailor: false,
      shakaAWSMediaTailorAdsParam: {},
      shakaAWSMediaTailorTrackingUrl: '',
      // should be common hls.js and Shaka but only available with Shaka for now
      disableVideo: false,
      disableAudio: false,
      disableText: false,
      disableThumbnails: false,
      disableIFrames: false,
      ignoreHardwareResolution: false,
      // hls 
      hlsJSFetchXhrWithCredentials: false,
      hlsJSCaptionsTextTrack1Label: 'CC1',
      hlsJSCaptionsTextTrack2Label: 'CC2',
      hlsJSCaptionsTextTrack3Label: 'CC3',
      hlsJSCaptionsTextTrack4Label: 'CC4',
      hlsJSAppleAppStoreCompliance: false,
      hlsJSStopDownloadWhilePaused: false,
      hlsJSCustomConfig: {},
      hlsJSFullCustomConfig: {},
      forceNativeHlsOverHlsJS: false,
      interstitialShowAdUI: true,
      //p2pMediaLoader 
      p2pMediaLoaderEngine: null,
      p2pMediaLoaderConfig: {},
      // DEPRECATED
      forceHlsJSOnAppleDevices: false,
      forceMseHlsOnAppleDevices: false,
      hlsJSProgressive: false,
      hlsJSMaxBufferAhead: 30,
      hlsJSMaxBufferBehind: 30,
      // common hls.js/shaka
      manualSwitchingMode: 'smooth', // Instant/Smooth/Conservative
      consumeLessEnergy: false,
      hlsEngine: 'hlsjs',
      capLevelToPlayerSize: true,
      ignoreDevicePixelRatio: false,
      lowLatencyMode: false,
      preferredKeySystems: [],
      videoPreference: {
        label: '',
        videoCodecs: ['vvc', 'vvi', 'av01', 'dvh', 'dva', 'dav', 'hvc', 'hev', 'vp09', 'avc', 'vp08'],
        videoHdr: 'auto'
      },
      audioPreference: {},
      subtitlePreference: {},
      //cmcd
      enableCMCD: false,
      useHeadersForCMCD: false,
      cmcdSessionId: '',
      cmcdContentId: '',
      cmcdVersion: 1,
      cmcdIncludeKeys: [],
      // cmsd (Shaka only)
      enableCMSD: false,
      // fps
      fpsDrm: {},
      //playback settings
      src: {},
      dashFirst: false,
      initialQuality: 0,
      pdCheckCodecsDone: false,
      labels: {},
      // live
      dvrUIThreshold: 300,
      // VttJS
      ccFiles: [],
      crossorigin: '',
      // fcc styling
      ccFontColor: 'white',
      ccFontOpacity: 1,
      ccFontSize: 1,
      ccFontFamily: 'arial',
      ccFontEdge: 'none',
      ccBackgroundColor: 'black',
      ccBackgroundOpacity: 0.5,
      ccWindowColor: 'black',
      ccWindowOpacity: 0,
      // transcripts
      transcripts: [],
      // GA
      enableGAVideoTracking: false,
      gaEventParameters: {},
      gaEvents: [],
      // Matomo
      enableMatomoTracking: false,
      dataMatomoTitle: '',
      // thumbnails 
      seekBarThumbnailsLoc: '',
      // chapters
      chaptersLoc: '',
      // cuePoints
      cuePoints: [],
      cuePointsVisibleOnTimeline: true,
      cuePointsCallback: null,
      // speed
      speed: false,
      speedRates: [0.25, 0.5, 1, 1.5, 2, 4],
      // googleCast
      googleCast: true,
      googleCastCordova: false,
      googleCastCordovaDebug: false,
      googleCastReceiverAppId: 'C899A03E',
      googleCastAndroidReceiverCompatible: false,
      googleCastVmapAdsRequest: '',
      googleCastAdTagUrl: '',
      googleCastHeaders: {},
      googleCastDrmToday: false,
      googleCastEnableUITextDisplayer: false,
      googleCastData: {},
      googleCastDisableAds: false,
      googleCastAllowSenderVolumeManagement: false,
      // airplay
      airplay: true,
      airplayWithMms: true,
      // ads
      ads: false,
      adTagUrl: '',
      adShowMarkers: true,
      adOnAdBlockPreventPlayback: false,
      // IMA
      adsResponse: '',
      adImaTest: false,
      adTagWaterfall: [],
      adLocale: 'auto',
      adUseStyledNonLinearAds: true,
      adVpaidMode: 'insecure',
      adContentDuration: 0,
      adContentKeywords: '',
      adContentTitle: '',
      adForceNonLinearFullSlot: false,
      adTagReloadOnEnded: true,
      adAutoAlign: true,
      adEnablePreloading: false,
      adCookiesEnabled: true,
      adLiveStreamPrefetchSeconds: 0,
      adContinuousPlayback: 'auto',
      adForceNativeFullscreenOnIosForAds: true,
      adNonLinearAdSlotWidth: -1,
      adNonLinearAdSlotHeight: -1,
      adCompanionBackfillMode: 'always',
      adPpid: '',
      adSessionId: '',
      omidAccessModeRules: {},
      // adSchedule
      adSchedule: {},
      adScheduleReloadOnEnded: true,
      adScheduleWaterfall: [],
      adScheduleCallback: null,
      // IMA DAI
      adImaDai: false,
      adImaDaiVodContentSourceId: '',
      adImaDaiVodVideoId: '',
      adImaDaiVodPod: false,
      adImaDaiVodPodRequestStreamURLCallback: null,
      adImaDaiLiveAssetKey: '',
      adImaDaiPodNetworkCode: '',
      adImaDaiCustomAssetKey: '',
      adImaDaiApiKey: '',
      adImaDaiBackupStream: '',
      adImaDaiAdTagParameters: {},
      adImaDaiStreamActivityMonitorId: '',
      adImaDaiAuthToken: '',
      // outstream IMA
      adOutStream: false,
      adOutStreamMutedAutoplay: true,
      // rmp-vast
      omidAllowedVendors: [],
      adOmidSupport: false,
      adAjaxWithCredentials: false,
      adRmpVastEnableVpaid: true,
      adSupportHlsCreatives: false,
      adRmpVastEnableSimid: true,
      // MIX
      adShowRemainingTime: false,
      adLoadMediaTimeout: 12000,
      adLoadVastTimeout: 8000,
      adMaxNumRedirects: 4,
      adCountDown: true,
      adParser: 'ima',
      adPageUrl: '',
      // related
      relatedLoc: '',
      relatedData: [],
      relatedUpNextOffset: 10,
      relatedUpNextAutoplay: true,
      relatedEndedLoop: false,
      relatedAudioOnly: false,
      relatedCallback: null,
      // playlist
      playlistLoc: '',
      playlistData: [],
      playlistUpNextAutoplay: true,
      playlistEndedLoop: false,
      playlistAudioOnly: false,
      playlistCallback: null,
      // 360
      video360: false,
      video360FocalLength: 65,
      video360MaxFocalLength: 115,
      video360MinFocalLength: 25,
      video360InitialLat: 0,
      video360InitialLon: 0,
      video360MobileGyroOffset: 45,
      video360FallbackSrc: {},
      // modules
      loopModule: false,
      infoModule: '',
      theaterModeModule: false,
      customModule: [],
      // MUX
      muxDataSettings: {},
      muxDataUseListData: true,
      // Bitmovin analytics
      bitmovinAnalyticsConfig: {},
      // PLATFORM Edition
      customAllowDenyListUrl: ''
    };
  }

  static get retryParameters() {
    return {
      manifest: {
        timeout: 25000,
        maxAttempts: 3,
        delay: 1000
      },
      levels: {
        timeout: 25000,
        maxAttempts: 3,
        delay: 1000
      },
      segment: {
        timeout: 60000,
        maxAttempts: 5,
        delay: 1000
      },
      steering: {
        timeout: 25000,
        maxAttempts: 3,
        delay: 1000
      },
      interstitial: {
        timeout: 25000,
        maxAttempts: 2,
        delay: 1000
      },
      drm: {
        timeout: 25000,
        maxAttempts: 3,
        delay: 1000
      }
    };
  }

  static get contentMetadata() {
    return {
      title: '',
      description: '',
      artist: '',
      album: '',
      id: '',
      releaseDate: '',
      thumbnail: '',
      duration: '',
      googleCastType: 'GENERIC',
      artwork: [],
      poster: [],
      endOfVideoPoster: [],
      animatedPoster: ''
    };
  }
}
